import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=6f367e64&scoped=true&"
import script from "./BottomMenu.vue?vue&type=script&lang=js&"
export * from "./BottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./BottomMenu.vue?vue&type=style&index=0&id=6f367e64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f367e64",
  null
  
)

export default component.exports